export default "__VITE_ASSET__SrQo9ABW__"